import React from 'react';
import { FooterTypes } from '../footerTypes';
import {
  FacilityAddressReachUs,
  EmailAddressReachUs,
  ContactNumberReachUs,
} from './FooterReachUsDetails';

export const ReachUsFacilityAddress = (
  reachUsDetails: FooterTypes.TContactDetailsFooter
) => {
  const { googleMapsUrl, facilityAddress } =
    reachUsDetails.contactDetails.facilityDetails;
  const addressDetails = {
    googleMapsUrl,
    facilityAddress,
  };
  return (
    <FacilityAddressReachUs
      reachUsDetails={reachUsDetails}
      address={addressDetails}
    />
  );
};

export const ReachUsEmailAddress = (
  reachUsDetails: FooterTypes.TContactDetailsFooter
) => {
  const { emailID } = reachUsDetails.contactDetails;

  return <EmailAddressReachUs reachUsDetails={reachUsDetails} mail={emailID} />;
};

export const ReachUsPhoneNumber = (
  reachUsDetails: FooterTypes.TContactDetailsFooter
) => {
  const { phoneNumber } = reachUsDetails.contactDetails;
  return (
    <ContactNumberReachUs
      reachUsDetails={reachUsDetails}
      phoneno={phoneNumber}
    />
  );
};
